// eslint-disable-next-line import/no-extraneous-dependencies
import Vue from 'vue';
import DatePicker from 'vuejs-datepicker';
import Vue2Datepicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

Vue.component('date-picker', DatePicker);
Vue.component('datetime-picker', Vue2Datepicker);
